// Educational scenarios only. Rates are percentages, not decimal fractions.
export function totalReturn(buy, sell, distribution = 0) {
  if (![buy, sell, distribution].every(Number.isFinite) || buy <= 0 || sell < 0 || distribution < 0) return null;
  return ((sell + distribution - buy) / buy) * 100;
}
export function recoveryAfterLoss(lossPercent) {
  if (!Number.isFinite(lossPercent) || lossPercent < 0 || lossPercent >= 100) return null;
  return lossPercent / (100 - lossPercent) * 100;
}
export function premiumToNav(price, nav) {
  if (![price, nav].every(Number.isFinite) || price < 0 || nav <= 0) return null;
  return (price / nav - 1) * 100;
}
export function portfolioReturn(stockWeight, stockReturn, bondReturn) {
  if (![stockWeight, stockReturn, bondReturn].every(Number.isFinite) || stockWeight < 0 || stockWeight > 100 || stockReturn < -100 || bondReturn < -100) return null;
  return stockWeight / 100 * stockReturn + (1 - stockWeight / 100) * bondReturn;
}
export function homeCurrencyReturn(assetReturn, startRate, endRate) {
  if (![assetReturn, startRate, endRate].every(Number.isFinite) || assetReturn < -100 || startRate <= 0 || endRate <= 0) return null;
  return ((1 + assetReturn / 100) * endRate / startRate - 1) * 100;
}
